(() => {
  'use strict';
  const omraChoices = ['omra', 'omra-en-groupe', 'omra-sur-mesure', 'omra-sans-agence'];
  const serviceChoices = ['services', 'guide', 'transfert', 'visite', 'hotels', 'mobilite-reduite'];
  const inferService = () => {
    const path = location.pathname;
    if (/voyage-omra/.test(path)) return 'voyage-omra';
    if (/inscription-nusuk/.test(path)) return 'inscription-nusuk-hajj';
    if (/badal|pelerinage-par-procuration/.test(path)) return 'badal';
    if (/sadaqa|offrir-(coran|repas|eau|fauteuil)|financer-puits|planter-arbre|aqiqa/.test(path)) return 'sadaqa';
    if (/\/pages\/hajj/.test(path)) return 'hajj';
    if (/guide-omra/.test(path)) return 'guide';
    if (/transferts/.test(path)) return 'transfert';
    if (/\/pages\/visites/.test(path)) return 'visite';
    if (/hotels-mecque/.test(path)) return 'hotels';
    if (/mobilite-reduite/.test(path)) return 'mobilite-reduite';
    if (/services-sur-place/.test(path)) return 'services';
    if (/omra-en-groupe|omra-sur-mesure|omra-sans-agence/.test(path)) return path.split('/').pop();
    if (/omra-ramadan/.test(path)) return 'omra-ramadan';
    return 'omra';
  };
  function init(root) {
    if (root.dataset.projectReady) return;
    const form = root.querySelector('form');
    const steps = [...root.querySelectorAll('[data-project-step]')];
    if (!form || steps.length !== 2) return;
    root.dataset.projectReady = 'true';
    const service = root.querySelector('[data-project-service]');
    const choice = root.querySelector('[data-project-choice]');
    const progress = root.querySelector('[data-project-progress]');
    const back = root.querySelector('[data-project-back]');
    const next = root.querySelector('[data-project-next]');
    const send = root.querySelector('[data-project-submit]');
    const recap = root.querySelector('[data-project-recap]');
    const error = root.querySelector('[data-project-error]');
    root.classList.add('cto-ux');
    const selectorStep = document.createElement('fieldset');
    const selectorTitle = document.createElement('legend'); selectorTitle.textContent = window.CTOFormUX.copy.need; selectorTitle.tabIndex = -1;
    selectorStep.append(selectorTitle, choice); steps[0].before(selectorStep);
    const navigation = document.createElement('div'); navigation.className = 'cto-ux-nav';
    const returnButton = document.createElement('button'); returnButton.type = 'button'; returnButton.textContent = `← ${window.CTOFormUX.copy.back}`;
    const stepStatus = document.createElement('span'); stepStatus.setAttribute('role','status');
    const meter = document.createElement('progress'); meter.setAttribute('aria-label', window.CTOFormUX.copy.progress);
    navigation.append(returnButton, stepStatus, meter); selectorStep.before(navigation);
    let current = root.querySelector('[data-cto-inquiry-error]') ? 1 : 0;
    let lastTracked = '';
    let contextChoices = [];
    const has = value => [...service.options].some(option => option.value === value);
    const isTravel = () => (service.value.startsWith('omra') && service.value !== 'omra-sans-agence') || service.value === 'voyage-omra';
    const track = () => {
      if (root.hidden) return;
      const key = `${service.value}:${current + 1}`;
      if (root.closest('dialog') && !root.closest('dialog').open) return;
      if (key === lastTracked || !window.CTOAnalytics || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      lastTracked = key;
      window.CTOAnalytics.capture('quote_step_viewed', { step: current + (contextChoices.length > 1 ? 2 : 1), service: service.value });
    };
    const updateService = () => {
      root.dataset.ctoService = service.value;
      const allowed = contextChoices;
      [...service.options].forEach(option => { option.hidden = !allowed.includes(option.value); option.disabled = option.hidden; });
      choice.hidden = allowed.length === 1;
      const contextTitle = root.querySelector('[data-project-context-title]');
      contextTitle.textContent = service.selectedOptions[0].textContent;
      contextTitle.hidden = !choice.hidden;
      const title = root.closest('dialog')?.querySelector('#CTOQuotePopupTitle');
      if (title) title.textContent = service.selectedOptions[0].textContent;
      root.querySelectorAll('[data-project-for]').forEach(group => {
        const modes = group.dataset.projectFor.split(' ');
        const visible = modes.includes(service.value) || (isTravel() && modes.includes('travel'));
        group.hidden = !visible;
        group.querySelectorAll('input,select,textarea').forEach(field => { field.disabled = !visible; });
      });
      const helpKey = service.value === 'omra-sans-agence' ? 'autonomy' : service.value === 'voyage-omra' ? 'voyage' : isTravel() ? 'omra' : ({hajj:'hajj','inscription-nusuk-hajj':'hajj',transfert:'transfer',guide:'guide',visite:'visits',hotels:'hotels','mobilite-reduite':'mobility',badal:'support',sadaqa:'support'})[service.value] || 'other';
      root.querySelector('[data-project-context-help]').textContent = root.querySelector(`[data-help="${helpKey}"]`).textContent;
      root.querySelector('[data-project-message]').open = ['badal','sadaqa','autre'].includes(service.value);
    };
    const makeRecap = () => {
      recap.replaceChildren();
      const heading = document.createElement('h3'); heading.textContent = root.dataset.summaryTitle; recap.append(heading);
      const list = document.createElement('dl');
      const add = (label, value) => { const dt = document.createElement('dt'); const dd = document.createElement('dd'); dt.textContent = label; dd.textContent = value; list.append(dt, dd); };
      add(steps[0].querySelector('legend').textContent, service.selectedOptions[0].textContent);
      steps[0].querySelectorAll('[data-project-label]').forEach(field => {
        if (field.disabled || !field.value.trim()) return;
        add(field.dataset.projectLabel, field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : field.value);
      });
      recap.append(list);
      const edit = document.createElement('button'); edit.type = 'button'; edit.className = 'link'; edit.textContent = root.dataset.edit; edit.addEventListener('click', () => show(0)); recap.append(edit);
      recap.hidden = false;
    };
    const show = (index, focus = true) => {
      current = index;
      root.dataset.projectStep = current === 1 ? '4' : String(current + 2);
      const choosing = current === -1;
      selectorStep.hidden = !choosing;
      steps.forEach((step, i) => { step.hidden = i !== current; });
      [...progress.children].forEach((item, i) => { if (i === current) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current'); });
      const extraStep = contextChoices.length > 1;
      returnButton.hidden = choosing || (!extraStep && current === 0);
      meter.max = extraStep ? 3 : 2; meter.value = current + (extraStep ? 2 : 1);
      stepStatus.textContent = `${meter.value} / ${meter.max}`;
      back.hidden = true; next.hidden = current !== 0; send.hidden = current !== 1;
      error.hidden = true;
      if (current === 1) makeRecap();
      if (focus) { (choosing ? selectorTitle : steps[current].querySelector('legend')).focus({preventScroll:true}); root.closest('.cto-popup__body')?.scrollTo(0,0); }
      track();
    };
    const valid = index => {
      const invalid = [...steps[index].querySelectorAll('input,select,textarea')].find(field => !field.disabled && !field.checkValidity());
      if (!invalid) return true;
      show(index, false); error.textContent = root.dataset.error; error.hidden = false;
      const details = invalid.closest('details'); if (details) details.open = true;
      invalid.setAttribute('aria-invalid','true'); invalid.focus(); invalid.reportValidity(); return false;
    };
    const selectContext = value => {
      if (!has(value)) value = inferService();
      if (value !== service.value) steps[0].querySelectorAll('input,textarea').forEach(field => { field.value = ''; });
      service.value = value;
      contextChoices = omraChoices.includes(value) ? omraChoices : value === 'services' ? serviceChoices.filter(item => item !== 'services') : [value];
      updateService();
    };
    const applyVoyage = voyage => {
      const assign = (selector, value) => { const field = root.querySelector(selector); if (field) field.value = value || ''; };
      assign('[data-project-voyage="destination"]',voyage.destination);
      assign('[data-project-voyage="order"]',voyage.order);
      assign('[data-project-voyage="stages"]',voyage.stages);
      assign('[data-project-voyage="comfort"]',voyage.comfort);
      assign('[data-project-voyage="wishes"]',Array.isArray(voyage.wishes) ? voyage.wishes.join(' · ') : '');
      assign('[name="contact[Periode souhaitee]"]',voyage.period);
      assign('[name="contact[Nombre de personnes]"]',String(voyage.people));
      assign('[name="contact[Ville de depart]"]',voyage.origin);
      assign('[name="contact[Budget indicatif]"]',voyage.budget);
      assign('[name="contact[body]"]',voyage.priorities);
    };
    selectContext(new URLSearchParams(location.search).get('service') || inferService());
    const params = new URLSearchParams(location.search);
    if (params.get('origin') === 'Marseille') {
      const origin = root.querySelector('[name="contact[Ville de depart]"]'); if (origin) origin.value = 'Marseille';
      const period = root.querySelector('[name="contact[Periode souhaitee]"]'); if (period && /^2027-\d{2}-\d{2}$/.test(params.get('departure') || '')) period.value = params.get('departure');
    }
    progress.hidden = false;
    form.noValidate = true;
    service.addEventListener('change', () => { updateService(); track(); });
    window.CTOFormUX.choices(service, () => show(0));
    form.addEventListener('input', event => event.target.removeAttribute('aria-invalid'));
    next.addEventListener('click', () => { if (valid(0)) show(1); });
    back.addEventListener('click', () => show(0));
    returnButton.addEventListener('click', () => show(current - 1));
    next.textContent = `${window.CTOFormUX.copy.contact_next} →`;
    form.addEventListener('submit', event => {
      if (current < 1) { event.preventDefault(); event.stopImmediatePropagation(); if (current === 0 && valid(0)) show(1); return; }
      for (let i=0;i<steps.length;i++) if (!valid(i)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    },true);
    root.closest('dialog')?.addEventListener('cto:popup-open', event => {
      selectContext(event.detail.service || inferService());
      const voyage = event.detail.voyageOmra;
      if (service.value === 'voyage-omra' && voyage && ['malaisie','thailande','maldives','lombok','conseil'].includes(voyage.destination)) { applyVoyage(voyage); show(1,false); }
      else show(event.detail.returnForm === form.id || root.querySelector('[data-cto-inquiry-error]') ? 1 : contextChoices.length > 1 ? -1 : 0,false);
    });
    document.addEventListener('visitorConsentCollected',track);
    root.closest('dialog')?.addEventListener('cto:popup-visible',track);
    show(contextChoices.length > 1 && current === 0 ? -1 : current,false);
  }
  document.querySelectorAll('[data-project-wizard]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-project-wizard]').forEach(init));
})();
